import { Injectable } from '@angular/core';
import { XhrService } from '../../core/services/xhr-service/xhr.service';
import { ActivatedSimDataDto, ValidateSimRequestDto, ValidateSimResponseDto } from './activate-sim.interface';
import { Observable } from 'rxjs';
import { API } from '../../global/API.constants';
import { strings } from '../../shared/functions/global-string.functions';
import { SessionStorageService } from '../../core/services/session-storage-service/session-storage.service';
import { GlobalConstants } from '../../global/global.constants';
import { LandingPageService } from '../landing-pages/landing-page.service';
import { FindUserByNicknevResponseDto } from '../personal-site/personal-site.interfaces';
import { OrderService } from '../order/order.service';
import { SwitchToPackageDto } from '../order/order.interfaces';
import { MobileServicesService } from '../mobile-services/mobile-services.service';
import { PartnerplusConstants } from '../../global/partnerplus.constants';
import { FindAllMobileServiceResponseDto } from '../mobile-services/mobile-services.interface';

@Injectable({
  providedIn: 'root',
})
export class ActivateSimService {
  unregisteredUsers: FindUserByNicknevResponseDto[] = PartnerplusConstants;

  constructor(
    private xhr: XhrService,
    private sessionStorageService: SessionStorageService,
    private landingPageService: LandingPageService,
    private orderService: OrderService,
    private mobileServicesService: MobileServicesService
  ) {}

  validateSim(request: ValidateSimRequestDto): Observable<ValidateSimResponseDto> {
    return this.xhr.get<ValidateSimResponseDto>(
      strings.replaceURLParams(API.activateSim.validateSim, { simNumber: request.simNumber }),
      null,
      null,
      false
    );
  }

  setDataAfterValidation(data: ValidateSimResponseDto, simNumber: string): void {
    const activatedSimData: ActivatedSimDataDto = {
      ...data,
      simNumber: simNumber,
    };
    this.sessionStorageService.setItem(
      GlobalConstants.sessionStorageKeys.simActivatedKey,
      JSON.stringify(activatedSimData)
    );
    if (data.userData) {
      this.landingPageService.setSimRecommender(data.userData);
    } else {
      //Ha itt error van, akkor a user az E-mag. Ezt külön le kell kezelni
      const user: FindUserByNicknevResponseDto = this.unregisteredUsers.find(
        (user) => +user.crmAzonosito === +data.viszonteladoId
      );
      if (user) {
        this.landingPageService.setSimRecommender(user);
      }
    }
  }

  findPackage(crmId: number, loyaltyMonth: number): FindAllMobileServiceResponseDto {
    return this.mobileServicesService.allMobileServices.find((item) => +item.crmAzonosito === +crmId) ?? null;
  }
  setPackageFromSim(switchToPackageData: SwitchToPackageDto, dontNavigate: boolean): Promise<void> {
    return new Promise<void>((resolve) => {
      this.orderService.selectedPhone = null;
      const foundPackage = this.findPackage(switchToPackageData.packageId, switchToPackageData.loyaltyMonth ?? 0);
      foundPackage.husegHonap = switchToPackageData.loyaltyMonth ? switchToPackageData.loyaltyMonth : 0;
      this.mobileServicesService.updateOrderObjectWithSelectedMobileService(foundPackage, dontNavigate);
      resolve();
    });
  }
}
